import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchSearchResults, SearchResults } from '../api';
import { transformFilters } from '../utils/helper';
import { defaultSearchFilters, initialSearch } from '../reducer';

export const getSearchResults = async (
  pageParam: number,
  search: Search,
  isArchive: boolean
): Promise<SearchResults> => {
  const searchFilters = transformFilters(search.filters);
  if (isArchive) searchFilters.hierarchy?.unshift('ARCHIVE');

  const offset = pageParam;
  const narrow = search.narrow;

  const data: SearchResults = await fetchSearchResults(
    search.searchQuery,
    searchFilters,
    offset,
    narrow
  );

  return data;
};

export const useGetSearchResults_V2 = (search: Search, isArchive: boolean = false) => {
  let searchFilters = transformFilters(search.filters);

  return useInfiniteQuery({
    queryKey: ['search-results', [search.searchQuery, searchFilters, search.narrow, isArchive]],
    queryFn: ({ pageParam }) => getSearchResults(pageParam, search, isArchive),
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      const loadedSoFar = allPages.flatMap((p) => p.hits).length;
      return loadedSoFar < (lastPage?.groupCount ?? 0) ? lastPageParam + 10 : undefined;
    },
    initialPageParam: 0,
    staleTime: 30000,
    retry: false,
  });
};

export const useGetSearchResultsByOrg = (selectedOrg: ExtendedOption | undefined) => {
  const splitArray = selectedOrg?.value.split('|');
  const hierarchy = splitArray ? [{ value: splitArray?.slice(0, 3).join('|') }] : [];
  const lob = { value: splitArray?.[3] };

  const newFilters = { hierarchy: hierarchy, line_of_business: lob };
  const newSearch: Search = {
    ...initialSearch,
    filters: {
      ...defaultSearchFilters,
      hierarchy: newFilters.hierarchy,
      line_of_business: newFilters.line_of_business,
    },
  };

  return useGetSearchResults_V2(newSearch, true);
};
